import * as React from 'react';
import { Note, UserNote, User, UserStyle } from '../../../models';
import { BaseRouteProps, EditProps } from '../../../interfaces';
import { FilterStore, UserStore } from '../../../stores';
import { NoteDataService } from '../../../services';
import { observer, inject } from 'mobx-react';
import { computed } from 'mobx';
import { PVAPage, PVABadge } from '../../../components';
import './notes.css';

interface MyReportState {
    selectedNote: Note;
    orgId: number;
    subject: string;
    content: string;
    id?: number;
}

interface MyReportProps extends BaseRouteProps<EditProps> {
    FilterStore?: FilterStore;
    UserStore?: UserStore;
}

@inject('FilterStore', 'UserStore') @observer
export class NotesCreate extends React.Component<MyReportProps, MyReportState> {
    private noteDataService = new NoteDataService(this.props.notificationService);

    constructor(props: MyReportProps) {
        super(props);
        var note = new Note();

        note.userNotes = [];

        this.state = {
            selectedNote: note,
            orgId: 0,
            subject: '',
            content: '',
            id: this.props.match.params.id
        };

        // Add the owner to the list of users by default.
        this.involveUser(this.user);
    }

    @computed get organization() {
        if (this.props.FilterStore && this.props.FilterStore.organization) {
            return this.props.FilterStore.organization;
        }
        return null;
    }
    @computed get users() {
        if (this.props.FilterStore && this.props.FilterStore.users) {
            return this.props.FilterStore.users;
        }
        return [];
    }
    @computed get userId() {
        if (this.props.UserStore && this.props.UserStore.userLoaded) {
            return this.props.UserStore!.userInfo.id;
        }
        return 0;
    }
    @computed get user() {
        let userInfo = this.props.UserStore!.userInfo;
        let user = new User();
        user.id = userInfo.id;
        user.userStyles = userInfo.userStyles;
        user.firstName = userInfo.firstName;
        user.lastName = userInfo.lastName;
        return user;
    }

    private update() {
        if (this.organization && this.organization.id !== this.state.orgId) {
            this.setState({
                orgId: this.organization.id
            });

            if (this.state.id) {
                this.noteDataService.get(this.state.id).then((note: Note) => {
                    this.setState({
                        selectedNote: note,
                        subject: note.subject,
                        content: note.content,
                    });
                });
            }
        }
    }

    componentDidMount() {
        this.update();
    }

    componentWillReact() {
        this.update();
    }

    private removeUser(u: User) {
        if (!this.state.selectedNote || !this.state.selectedNote.userNotes) {
            return;
        }

        var ind = this.state.selectedNote.userNotes.findIndex((un: UserNote) => {
            return un.user.id === u.id;
        });
        if (ind > -1) {
            var note = this.state.selectedNote;
            note.userNotes.splice(ind, 1);
            this.setState({
                selectedNote: note
            });
        }
    }

    private userSelected(e: any) {
        const userId = Number(e.target.value);
        this.involveUserById(userId);
    }

    private involveUserById(userId: Number) {
        this.involveUser(
            this.users.find((u: User) => {
                return u.id === userId;
            })!
        );
    }

    private involveUser(user: User) {
        if (user && this.state.selectedNote && this.state.selectedNote.userNotes) {
            var note = this.state.selectedNote;
            var un = new UserNote();
            un.user = user;
            un.userID = user.id;
            note.userNotes.push(un);
            this.setState({
                selectedNote: note
            });
        }
    }

    private create() {
        this.setNoteState();
        this.noteDataService.create(this.state.selectedNote).then((n: Note) => {
            // success
            this.props.history.push('/notes');
        });
    }

    private updateNote() {
        this.setNoteState();
        this.noteDataService.update(this.state.selectedNote).then((n: Note) => {
            // success
            this.props.history.push('/notes');
        });
    }

    private setNoteState() {
        this.state.selectedNote.userNotes = this.state.selectedNote.userNotes || [];
        this.state.selectedNote.subject = this.state.subject;
        this.state.selectedNote.content = this.state.content;
    }

    private getPVABadge(styles: UserStyle[]) {
        if (styles  && styles.length > 0) {
            return <span className="pva-badge-tiny pva-badge-tiny-space-left"><PVABadge style={styles[0].style.name} badge={styles[0].style.name[0]} /></span>;
        } else {
            return <span className="pva-badge-tiny pva-badge-tiny-space-left"><PVABadge style={''} badge={''} /></span>;
        }
    }

    private newNote() {
        if (this.state.id) {
            return <a className="btn btn-primary" onClick={(e) => this.updateNote()}>Update</a>;
        } else {
            return <a className="btn btn-primary" onClick={(e) => this.create()}>Create</a>;
        }
    }

    public render() {
        return (
            <PVAPage>
            
                {this.organization && <div id={`organization-${this.organization.id}`} />}
                
                <PVAPage.Header>
                    <PVAPage.Header.Title>
                        <PVAPage.Header.Title.Text>
                            Exchange Notes
                            {!this.state.id && <span> - Create</span>}
                        </PVAPage.Header.Title.Text>
                    </PVAPage.Header.Title>
                </PVAPage.Header>

                <PVAPage.Body>
                    <div className="row">
                        <div className="col-xs-7">
                            <div className="form-group">
                                <label>People Involved</label>
                                <select className="form-control" value={-1} onChange={(e) => this.userSelected(e)}>
                                    <option value={-1}>-- Select User To Add --</option>
                                    {this.users.map((user: User, ind: number) => {
                                        return <option key={`user-${ind}`} value={user.id}>{user.firstName} {user.lastName}</option>;
                                    })}
                                </select>
                            </div>
                            <div className="form-group">
                                <label>Regarding</label>
                                <input type="text" className="form-control" value={this.state.subject} onChange={(e) => this.setState({subject: e.target.value})} />
                            </div>
                            <div className="form-group">
                                <label>Notes</label>
                                <textarea className="form-control notes-content"  value={this.state.content.replace(/<br \/>/g, '\n')} onChange={(e) => this.setState({content: e.target.value})}/>
                            </div>
                            {this.newNote()}
                        </div>
                        <div className="col-xs-5">
                            <label>Added People</label>
                            {
                                this.state.selectedNote && this.state.selectedNote.userNotes && this.state.selectedNote.userNotes.map((un: UserNote, ind: number) => {
                                    return <div key={`selected-user-${ind}`} className="notes-user-row user-label show-remove">
                                        {this.getPVABadge(un.user.userStyles)}
                                        <span className="users-name">{un.user.firstName} {un.user.lastName}</span>
                                        <span className="pull-right">
                                            <a className="show-hover" onClick={(e) => this.removeUser(un.user)}>
                                                <span className="glyphicon glyphicon-remove highlight-hover" />
                                            </a>
                                        </span>
                                    </div>;
                                })
                            }
                        </div>
                    </div>
                </PVAPage.Body>
                <PVAPage.Footer />
            </PVAPage>);
    }
}



// WEBPACK FOOTER //
// ./src/components/reports/notes/NotesCreate.tsx